import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';

const DynamicAboutContent = dynamic(() => import('../components/about/about'), {
  suspense: true
});

const About = () => {
  return (
    <>
      <Head>
        <meta name="description" content="About me - Eloïc Ah-hing" />
      </Head>
      <Suspense fallback={'Loading...'}>
        <DynamicAboutContent />
      </Suspense>
    </>
  );
};

export const getStaticProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ['about']))
  }
});

export default About;
